import { render, staticRenderFns } from "./ReferralsAdvertisment.vue?vue&type=template&id=32fa6a0a&scoped=true&"
import script from "./ReferralsAdvertisment.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReferralsAdvertisment.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReferralsAdvertisment.vue?vue&type=style&index=0&id=32fa6a0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fa6a0a",
  null
  
)

export default component.exports